// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--2GWwS";
export var list = "styles-module--list--bzVxu";
export var element = "styles-module--element--29Mpn";
export var coluna = "styles-module--coluna--A9sfH";